import ServicesShow from "../components/Services/Show";

export default [
  { name: 'Services', path: '/services', component: ServicesShow, meta: {  showHeaderBanner: false }}
]
